import { Box, Typography, useTheme } from '@mui/material';
import { useCreateExercise } from '_api';
import { ExercisePayload } from '_api/types';
import { AdminRouteMap } from '_constants';
import { SEVERITY } from '_constants/derived';
import { DefaultNewExercise } from '_constants/object-templates';
import { TextButton } from 'components/atoms';
import { AlertMessage } from 'components/molecules';
import { ExerciseForm } from 'components/organisms/forms';
import React, { useState } from 'react';
import { IoArrowBackOutline } from 'react-icons/io5';
import { useNavigateTo } from 'utils';
import { useUser } from 'utils/hooks';

export const AddExercise = () => {
  const theme = useTheme();
  const navigate = useNavigateTo();
  const { mutateAsync: createExercise } = useCreateExercise();
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const { isAdmin } = useUser();

  const onBack = () => {
    history.back();
  };

  const onSubmit = (submitExercise: ExercisePayload) => {
    createExercise(submitExercise)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => {
            navigate(AdminRouteMap.LIBRARY);
          }, 1500);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          setErrorMessage(
            'Unexpected error occured. Please refresh the page and try again.',
          );
        } else if (error.message) {
          setErrorMessage(`ERROR: ${error.message}`);
        } else {
          setErrorMessage('Unexpected error. Please Try again.');
        }
      });
  };

  return (
    <Box style={{ padding: 0 }}>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'left' }}>
          Add Exercise
        </Typography>
        <TextButton
          onClick={onBack}
          sx={{ color: theme.palette.primary.main, marginBottom: '10px', paddingLeft: 0 }}
        >
          <IoArrowBackOutline />
          BACK
        </TextButton>
      </Box>
      <ExerciseForm
        disableAll={showSuccess}
        initValue={{
          ...DefaultNewExercise,
          shareWithOrg: isAdmin,
        }}
        onBack={onBack}
        onSubmit={onSubmit}
      />
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Exercise successfully created'}
      />
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={errorMessage}
      />
    </Box>
  );
};
